import React from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageBreadcrumbs from '../components/Breadcrumbs';

const BillingSubscribe: React.FC = () => {
  const { t } = useTranslation();
  const adminEmail = (import.meta as any).env.VITE_APP_ADMIN_EMAIL as string | undefined;

  return (
    <Container maxWidth="sm">
      <Box mt={4}>
        <PageBreadcrumbs
          items={[
            { label: t('nav.dashboard'), path: '/dashboard' },
            { label: t('nav.billingStore') },
          ]}
        />
        <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
              {t('billing.subscribe.title', 'Subscription required')}
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              {t('billing.subscribe.noSubscription', 'Your organization does not have an active subscription.')}
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              {adminEmail
                ? t('billing.subscribe.contactAdmin', { email: adminEmail, defaultValue: `Contact the application administrator at ${adminEmail} regarding payment.` })
                : t('billing.subscribe.contactAdminGeneric', 'Contact the application administrator regarding payment.')
              }
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('billing.subscribe.automationNote', 'We are working on automating this process.')}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default BillingSubscribe;
